// extracted by mini-css-extract-plugin
module.exports = {"loader-wrapper":"Loader_loader-wrapper__1hOyb","dots-loader":"Loader_dots-loader__mlJqN"};